import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import styles from "./TileSkeleton.module.scss";
import { TileSkeletonProps } from "./types";

/**
 * TileSkeleton component represents a loading placeholder for tiles
 * Used during lazy loading to maintain layout and provide visual feedback
 *
 * Inherits dimensions from CSS variables defined in platform-specific classes:
 * --skeleton-tile-width, --skeleton-tile-height, --skeleton-border-radius
 *
 * @param className - Additional class names for styling (must include platform class with CSS variables)
 *
 * @example
 * ```tsx
 * // Tile34 usage
 * <TileSkeleton className={classNames(styles["tile-34"], styles[`platform-${platform}`])} />
 *
 * // MiniGameTile usage
 * <TileSkeleton className={classNames(styles["mini-game-tile"], styles[`platform-${platform}`])} />
 *
 * // SecondaryNavTile usage
 * <TileSkeleton className={classNames(styles["secondary-nav-tile"], styles[`platform-${platform}`])} />
 * ```
 */
const TileSkeleton = ({ className }: TileSkeletonProps) => {
  const cn = classNames(styles["tile-skeleton"], className);

  return (
    <div className={cn}>
      <div className={styles["skeleton-shimmer"]} />
    </div>
  );
};

export { TileSkeleton };
